import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon, Link } from '@paypalcorp/pp-react';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import AriaTooltipComponent from './common/tooltipComponent/AriaTooltipComponent';
import { disableTopicTree } from '../../lib/globalHelper';
import { iconNames } from '../../common/commonConstants';

const recommend = i18n.message('smarthelp/contactOption.recommend');
// const chat = i18n.message('smarthelp/contactOption.chat');
const tooltip = i18n.message('smarthelp/contactOption.recommended.tooltip');

class ContactOption extends Component {
  static getTopicTreeDisabledStyle() {
    return disableTopicTree() ? { float: 'none' } : {};
  }

  static renderIcon(key) {
    const size = 'xl';
    switch (key) {
      case iconNames.RESOLUTION:
        return <Icon name="resolution" size={size} />;
      case iconNames.CONTACT_US:
        return <Icon name="contact-us" size={size} />;
      case iconNames.CHAT:
      case iconNames.MESSAGE:
        return <Icon name="chat" size={size} />;
      case iconNames.CHAT_BOT:
        return <Icon name="paypal-assistant" size={size} />;
      case iconNames.EMAIL_US:
      case iconNames.EMAIL:
        return <Icon name="email" size={size} />;
      case iconNames.CALL_US:
        return <Icon name="phone-2" size={size} />;
      case iconNames.SCHEDULE_CALLBACK:
        return <Icon name="calendar" size={size} />;
      case iconNames.DEVELOPER:
        return <Icon name="code" size={size} />;
      case iconNames.SITE:
        return <Icon name="warning" size={size} />;
      case iconNames.BRAINTREE_SUPPORT:
        return <Icon name="help" size={size} />;
      case iconNames.BUSINEE:
        return <Icon name="merchant" size={size} />;
      case iconNames.COMMUNITY:
      default:
        return <Icon name="community" size={size} />;
    }
  }

  renderRecommended() {
    if (!this.props.recommended) {
      return null;
    }
    return (
      <div className="recommended">
        <AriaTooltipComponent message={tooltip} direction="bottom">
          <button className="icon-recommended">{recommend}</button>
        </AriaTooltipComponent>
      </div>
    );
  }

  renderMessage() {
    return this.props.message ? (
      <div className={this.props.supportMessageCSS}>
        {Page.getHTMLElement({ message: this.props.message, useHTML: true })}
      </div>
    ) : null;
  }

  renderContactText() {
    const attrs = {
      className: this.props.contactLinkCSS,
      'aria-label': `${this.props.text}, ${this.props.message ?? ''}`,
    };

    if (this.props.tabIndex) {
      attrs.tabIndex = this.props.tabIndex;
    }

    if (this.props.link) {
      attrs.onClick = (e) => {
        e.preventDefault();
        return this.props.clickAction();
      };
      attrs.href = this.props.link;
      attrs.target = this.props.sameTab ? '' : '_blank';

      return <Link {...attrs}>{this.props.text}</Link>;
    }

    attrs.onClick = () => this.props.clickAction();

    return <button {...attrs}>{this.props.text}</button>;
  }

  render() {
    const attrs = {
      className: 'contact-panel',
      id: `contact-${this.props.id}`,
      style: ContactOption.getTopicTreeDisabledStyle(),
    };

    return (
      <div {...attrs}>
        {ContactOption.renderIcon(this.props.id)}
        <div className="channel-content">
          {this.renderContactText()}
          {this.renderMessage()}
          {this.renderRecommended()}
        </div>
      </div>
    );
  }
}

ContactOption.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  contactLinkCSS: PropTypes.string.isRequired,
  clickAction: PropTypes.func.isRequired,
  iconClass: PropTypes.string.isRequired,
  supportMessageCSS: PropTypes.string.isRequired,
  recommended: PropTypes.bool,
  // toolTip: PropTypes.bool,
  link: PropTypes.string,
  sameTab: PropTypes.bool,
  tabIndex: PropTypes.number,
};

ContactOption.defaultProps = {
  recommended: false,
  // toolTip: false,
  link: undefined,
  sameTab: false,
  datapaClick: '',
  tabIndex: 0,
};

export default ContactOption;
